"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeRenameRuleForm = exports.initializeMemorizedPayeeForm = exports.mkDatasetItemArray = exports.mkBudgetItemArray = exports.checkForDuplicateTag = exports.sortTagData = exports.makeLocalTagData = exports.getTxnsToChange = exports.reassignMemPayeeCat = exports.reassignTxnCat = exports.txnHasCat = exports.checkForDuplicateCategory = exports.getCategoryDepth = exports.getCategoryById = exports.makeNewCategoryObject = exports.makeLocalCategoriesData = exports.checkForDuplicates = exports.compareFields = exports.findIdInData = exports.getInstitutionBranding = exports.getManualAccounts = void 0;
const deep_equal_1 = __importDefault(require("deep-equal"));
const immutable_1 = require("immutable");
const accounts_1 = require("companion-app-components/flux/accounts");
const chart_of_accounts_1 = require("companion-app-components/flux/chart-of-accounts");
const transactions_1 = require("companion-app-components/flux/transactions");
const transactionsTypes_1 = require("companion-app-components/flux/transactions/transactionsTypes");
const getManualAccounts = (accountsByInstitutionLoginId, institutionLogins, manageAccountsGroupManualByType) => {
    let unattachedAccounts = accountsByInstitutionLoginId && accountsByInstitutionLoginId.get('0');
    if (!unattachedAccounts) {
        unattachedAccounts = (0, immutable_1.List)();
    }
    // Need to handle case where client (i.e. Windows) adds all manual accounts to an InstitutionLogin. We recognize
    // this by seeing if the institutionId is '0' and the name is not set. The reason we check for name is so that
    // manual grouped accounts can be supported by adding to an InstitutionLogin with a valid name.
    if (institutionLogins) {
        institutionLogins.valueSeq().forEach((institutionLogin) => {
            if (institutionLogin.institutionId === '0' && institutionLogin.name === 'unknown') {
                const accounts = accountsByInstitutionLoginId ? accountsByInstitutionLoginId.get(institutionLogin.id) : null;
                if (accounts) {
                    unattachedAccounts = unattachedAccounts === null || unattachedAccounts === void 0 ? void 0 : unattachedAccounts.concat(accounts);
                }
            }
        });
    }
    let accountsManual = null;
    if (manageAccountsGroupManualByType) {
        accountsManual = {};
        const manualBankingAccounts = unattachedAccounts.filter((account) => accounts_1.accountsSelectors.isCashAccount(account)).sortBy((account) => account.name);
        accountsManual.banking = manualBankingAccounts.size > 0 ? manualBankingAccounts : null;
        const manualInvestingAccounts = unattachedAccounts.filter((account) => accounts_1.accountsSelectors.isInvestmentAccount(account)).sortBy((account) => account.name);
        accountsManual.investments = manualInvestingAccounts.size > 0 ? manualInvestingAccounts : null;
        const manualAssetsAndLiabilitiesAccounts = unattachedAccounts.filter((account) => accounts_1.accountsSelectors.isAssetLiabilityAccount(account)).sortBy((account) => account.name);
        accountsManual.assetsAndLiabilties = manualAssetsAndLiabilitiesAccounts.size > 0 ? manualAssetsAndLiabilitiesAccounts : null;
    }
    else {
        accountsManual = unattachedAccounts.size > 0
            ? unattachedAccounts.filter((account) => !accounts_1.accountsSelectors.isGoalAccount(account)).sortBy((account) => account.name)
            : null;
        if (accountsManual && accountsManual.size === 0) {
            accountsManual = null;
        }
    }
    return accountsManual;
};
exports.getManualAccounts = getManualAccounts;
const getInstitutionBranding = (institutionsParam, id) => institutionsParam.find((institution) => institution.id === id) || null;
exports.getInstitutionBranding = getInstitutionBranding;
const findIdInData = (id, records) => {
    let foundRecord = null;
    records.some((record) => {
        if (record.id === id) {
            foundRecord = record;
            return true;
        }
        if (record.children) {
            foundRecord = (0, exports.findIdInData)(id, record.children);
            return foundRecord !== null;
        }
        return false;
    });
    return foundRecord;
};
exports.findIdInData = findIdInData;
const compareFields = (existingRecord, candidateRecord, fieldDefinition) => {
    if (existingRecord.values && existingRecord.values[fieldDefinition.id]) {
        return (0, deep_equal_1.default)(existingRecord.values[fieldDefinition.id], candidateRecord.values[fieldDefinition.id]);
    }
    return existingRecord[fieldDefinition.id] === candidateRecord[fieldDefinition.id];
};
exports.compareFields = compareFields;
const checkForDuplicates = (records, dataDictionary, candidateRecord) => {
    const uniqueFields = dataDictionary.filter((fieldDefinition) => fieldDefinition.unique || fieldDefinition.uniqueWith);
    let duplicateField = null;
    if (uniqueFields) {
        records.forEach((existingRecord) => {
            let matchingField = null;
            uniqueFields.forEach((fieldDefinition) => {
                if (existingRecord[fieldDefinition.id] === candidateRecord[fieldDefinition.id]
                    && existingRecord.id !== candidateRecord.id) {
                    matchingField = fieldDefinition.id;
                }
                if (matchingField && fieldDefinition.uniqueWith) {
                    let relatedFieldsMatched = true;
                    fieldDefinition.uniqueWith.forEach((relatedFieldId) => {
                        const relatedFieldDefinition = dataDictionary.find((dataField) => dataField.id === relatedFieldId);
                        if (!(0, exports.compareFields)(existingRecord, candidateRecord, relatedFieldDefinition)) {
                            relatedFieldsMatched = false;
                        }
                    });
                    if (!relatedFieldsMatched) {
                        matchingField = null;
                    }
                }
            });
            duplicateField = matchingField || duplicateField;
            if (existingRecord.children && !duplicateField) {
                duplicateField = duplicateField || (0, exports.checkForDuplicates)(existingRecord.children, dataDictionary, candidateRecord);
            }
        });
    }
    return duplicateField;
};
exports.checkForDuplicates = checkForDuplicates;
const crawlCategoryList = (coaNode, categories, flatten, parentCache, level = 1) => {
    const category = categories.get(coaNode.id);
    if (category && !category.isExcludedFromCategoryList) {
        let childData = null;
        if (coaNode.children) {
            childData = [];
            coaNode.children.forEach((node) => {
                childData = childData && childData.concat(crawlCategoryList(node, categories, flatten, parentCache, level + 1));
            });
        }
        const parent = Number(category.parentId)
            ? parentCache.get(category.parentId) || chart_of_accounts_1.chartOfAccountsSelectors.getCoaStringSelector(undefined, { type: 'CATEGORY', id: category.parentId }, true)
            : '';
        parentCache.set(category.parentId, parent);
        const parentCatType = ['', '0'].includes(category.parentId)
            ? chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.NONE
            : chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.CATEGORY;
        const categoryRow = [{
                id: category.id,
                name: category.name,
                description: category.description,
                categoryType: String(category.type),
                isExcludedFromBudgets: Boolean(category.isExcludedFromBudgets),
                isDeleted: category.isDeleted,
                parent,
                values: {
                    parent: { type: parentCatType, id: category.parentId },
                },
                children: childData,
                level,
            }];
        // @ts-expect-error: No overload matches this call.
        return flatten && childData ? categoryRow.concat(childData) : categoryRow;
    }
    return [{ id: 0 }];
};
const makeLocalCategoriesData = ({ categories, chartOfAccounts, flatten }) => {
    if (!categories) {
        return [];
    }
    let data;
    if (chartOfAccounts) {
        const parentCache = new Map();
        let categoryRows = [];
        chartOfAccounts.forEach((coaNode) => {
            const categoryBranch = crawlCategoryList(coaNode, categories, flatten, parentCache);
            // @ts-expect-error: No overload matches this call.
            categoryRows = categoryRows.concat(categoryBranch);
        });
        data = (0, immutable_1.List)(categoryRows).filter((categoryRow) => categoryRow.id !== 0);
    }
    return data;
};
exports.makeLocalCategoriesData = makeLocalCategoriesData;
const makeNewCategoryObject = (newCategoryId = '0') => ({
    values: {
        parent: { id: '0', type: chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.NONE },
    },
    parent: '',
    id: newCategoryId,
    name: '',
    categoryType: 'EXPENSE',
    description: '',
    isExcludedFromBudgets: false,
    isNewCategory: true,
    level: 1,
    children: null,
});
exports.makeNewCategoryObject = makeNewCategoryObject;
const getCategoryById = (id, flatData) => flatData.find((categoryRecord) => categoryRecord.id === id);
exports.getCategoryById = getCategoryById;
const getCategoryDepth = (category, level = 1) => {
    let deep = level;
    if (category.children) {
        const childrenCount = [];
        deep += 1;
        category.children.forEach((cat, index) => {
            childrenCount[index] = cat.children ? (0, exports.getCategoryDepth)(cat, deep) : deep;
        });
        deep = Math.max(...childrenCount);
    }
    return deep;
};
exports.getCategoryDepth = getCategoryDepth;
const checkForDuplicateCategory = (category, parentCategory, flatData) => {
    if (!parentCategory.children) {
        const newData = flatData.filterNot((objCategory) => objCategory.id === category.id || objCategory.level !== 1);
        const groupData = newData.groupBy((x) => x.name).mapKeys((x) => x.toLowerCase());
        return Boolean(groupData.get(category.name.toLowerCase().trim()));
    }
    return parentCategory.children.some((objCategory) => objCategory.level === parentCategory.level + 1 && objCategory.name.toLowerCase() === category.name.toLowerCase().trim());
};
exports.checkForDuplicateCategory = checkForDuplicateCategory;
const txnHasCat = (transactionRecord, category) => {
    if (transactions_1.transactionsUtils.isSplitTxn(transactionRecord)) {
        const matchingSplitItem = transactionRecord.split.items.find((splitItem) => splitItem.coa && splitItem.coa.id === category.id);
        return Boolean(matchingSplitItem);
    }
    return transactionRecord.coa && transactionRecord.coa.id === category.id;
};
exports.txnHasCat = txnHasCat;
const isCurrentOrDescendantCategory = (coaId, category) => {
    if (coaId === category.id)
        return true;
    if (category.children && category.children.length > 0) {
        return category.children.some((child) => isCurrentOrDescendantCategory(coaId, child));
    }
    return false;
};
const reassignTxnCat = (transactionRecord, currentCategory, replacementCategory) => {
    var _a;
    const replacementCoa = chart_of_accounts_1.chartOfAccountsTypes.mkChartOfAccount({ id: replacementCategory.id, type: replacementCategory.type });
    if (!(transactionRecord instanceof transactionsTypes_1.CashFlowTransaction)) {
        if (transactions_1.transactionsUtils.isSplitTxn(transactionRecord)) {
            return Object.assign(Object.assign({}, transactionRecord), { split: {
                    items: transactionRecord.split.items.map((splitItem) => {
                        const updatedSplitItem = splitItem instanceof transactionsTypes_1.CashFlowTransaction
                            ? splitItem.set('coa', replacementCoa)
                            : Object.assign(Object.assign({}, splitItem), { coa: replacementCoa });
                        return splitItem.coa && isCurrentOrDescendantCategory(splitItem.coa.id, currentCategory) ? updatedSplitItem : splitItem;
                    }),
                } });
        }
        return Object.assign(Object.assign({}, transactionRecord), { coa: replacementCoa });
    }
    if (transactions_1.transactionsUtils.isSplitTxn(transactionRecord) && ((_a = transactionRecord === null || transactionRecord === void 0 ? void 0 : transactionRecord.split) === null || _a === void 0 ? void 0 : _a.items)) {
        return transactionRecord.setIn(['split', 'items'], transactionRecord.split.items.map((splitItem) => splitItem.coa && isCurrentOrDescendantCategory(splitItem.coa.id, currentCategory)
            ? splitItem.set('coa', replacementCoa)
            : splitItem));
    }
    return transactionRecord.set('coa', replacementCoa);
};
exports.reassignTxnCat = reassignTxnCat;
const reassignMemPayeeCat = (txn, cat, newCat) => {
    const newCoa = chart_of_accounts_1.chartOfAccountsTypes.mkChartOfAccount({ id: newCat.id, type: newCat.type });
    if (transactions_1.transactionsUtils.isSplitTxn(txn)) {
        return txn.setIn(['split', 'items'], txn.split.items.map((item) => {
            if (item.coa && isCurrentOrDescendantCategory(item.coa.id, cat)) {
                return 'set' in item && typeof item.set === 'function' ? item.set('coa', newCoa) : Object.assign(Object.assign({}, item), { coa: newCoa });
            }
            return item;
        }));
    }
    return txn.set('coa', newCoa);
};
exports.reassignMemPayeeCat = reassignMemPayeeCat;
const getTxnsToChange = (category, txnsProps) => {
    const transactionsToChangeForCategory = txnsProps.transactionsById.filter((transactionRecord) => (0, exports.txnHasCat)(transactionRecord, category));
    const scheduledTransactionsToChangeForCategory = txnsProps.scheduledTransactions.filter((scheduledTransaction) => (0, exports.txnHasCat)(scheduledTransaction.transaction, category));
    const memorizedTransactionsToChangeForCategory = txnsProps.memTransactionsById.filter((memorizedTransaction) => (0, exports.txnHasCat)(memorizedTransaction, category));
    if (category.children && category.children.length > 0) {
        let descendantTransactionsToChange = (0, immutable_1.Map)({});
        let descendantScheduledTransactionsToChange = (0, immutable_1.Map)({});
        let descendantMemorizedTransactionsToChange = (0, immutable_1.Map)({});
        category.children.forEach((childCategory) => {
            const childTransactionsToChange = (0, exports.getTxnsToChange)(childCategory, txnsProps);
            descendantTransactionsToChange = descendantTransactionsToChange.merge(childTransactionsToChange.txnsToChange);
            descendantScheduledTransactionsToChange =
                descendantScheduledTransactionsToChange.merge(childTransactionsToChange.scheduledTxnsToChange);
            descendantMemorizedTransactionsToChange =
                descendantMemorizedTransactionsToChange.merge(childTransactionsToChange.memTransactionToChange);
        });
        return {
            txnsToChange: descendantTransactionsToChange.merge(transactionsToChangeForCategory),
            scheduledTxnsToChange: descendantScheduledTransactionsToChange.merge(scheduledTransactionsToChangeForCategory),
            memTransactionToChange: descendantMemorizedTransactionsToChange.merge(memorizedTransactionsToChangeForCategory),
        };
    }
    return {
        txnsToChange: transactionsToChangeForCategory,
        scheduledTxnsToChange: scheduledTransactionsToChangeForCategory,
        memTransactionToChange: memorizedTransactionsToChangeForCategory,
    };
};
exports.getTxnsToChange = getTxnsToChange;
const makeLocalTagData = (tags) => (!tags ? (0, immutable_1.List)() : tags.toList());
exports.makeLocalTagData = makeLocalTagData;
const sortTagData = (tagRecords) => {
    if (tagRecords.size === 0) {
        return tagRecords;
    }
    const sortedTagRecords = tagRecords.sort((tagRecord1, tagRecord2) => {
        if ((0, immutable_1.isImmutable)(tagRecord1) && (0, immutable_1.isImmutable)(tagRecord2)) {
            // @ts-expect-error: Object is of type 'unknown'.
            return tagRecord1.get('createdAt') > tagRecord2.get('createdAt') ? -1 : 1;
        }
        return 0;
    });
    const unsavedTagIndex = sortedTagRecords.findIndex((tagRecord) => tagRecord.get('createdAt') === undefined);
    if (unsavedTagIndex >= 0) {
        const unsavedTagRecord = sortedTagRecords.get(unsavedTagIndex);
        return sortedTagRecords.delete(unsavedTagIndex).unshift(unsavedTagRecord);
    }
    return sortedTagRecords;
};
exports.sortTagData = sortTagData;
const checkForDuplicateTag = (id, name, tagData, checkAll = false) => {
    var _a;
    const tagRecordsToCheck = checkAll ? tagData : tagData.filterNot((tagRecord) => tagRecord.get('id') === id);
    const tagsGroupedByName = tagRecordsToCheck === null || tagRecordsToCheck === void 0 ? void 0 : tagRecordsToCheck.groupBy((tagRecord) => tagRecord.get('name')).mapKeys((groupKey) => groupKey === null || groupKey === void 0 ? void 0 : groupKey.toLowerCase());
    return Boolean(tagsGroupedByName === null || tagsGroupedByName === void 0 ? void 0 : tagsGroupedByName.get((_a = name.trim()) === null || _a === void 0 ? void 0 : _a.toLowerCase()));
};
exports.checkForDuplicateTag = checkForDuplicateTag;
const mkBudgetItemArray = (budgets) => {
    if (!budgets) {
        return (0, immutable_1.List)();
    }
    let budgetItems = (0, immutable_1.List)();
    budgets.forEach((budget) => {
        if (!budget.isDeleted) {
            budgetItems = budgetItems.push({
                id: budget.id,
                name: budget.name,
            });
        }
    });
    return budgetItems;
};
exports.mkBudgetItemArray = mkBudgetItemArray;
const mkDatasetItemArray = (finances) => {
    if (!finances) {
        return (0, immutable_1.List)();
    }
    let datasetItems = (0, immutable_1.List)();
    finances.forEach((finance) => {
        datasetItems = datasetItems.push({ id: finance.id, name: finance.name });
    });
    return datasetItems;
};
exports.mkDatasetItemArray = mkDatasetItemArray;
const initializeMemorizedPayeeForm = (memorizedPayeeRecord) => (Object.assign(Object.assign({}, memorizedPayeeRecord.toJS()), { payee: { payee: memorizedPayeeRecord.payee } }));
exports.initializeMemorizedPayeeForm = initializeMemorizedPayeeForm;
const initializeRenameRuleForm = (renameRuleRecord) => renameRuleRecord.toJS();
exports.initializeRenameRuleForm = initializeRenameRuleForm;
